import React from "react";
import FormattedDate from "./formattedDate";
import WeatherIcon from "./weatherIcon";
import WeatherTemperature from "./weatherTemperature";
import "./weatherInfo.css";

export default function WeatherInfo(props) {
  return (
    <div className="weatherInfo">
      <div className="row todaysInfo">
        <ul>
          <li className="location">
            {props.data.city}, {props.data.country}
          </li>
          <li className="date">
            <FormattedDate date={props.data.date} />
          </li>
          <li className="description">
            <span className="text-capitalize">{props.data.description}</span>
          </li>
        </ul>
      </div>
      <div className="row">
        <div className="col-2">
          <WeatherIcon code={props.data.icon} size={131} />
        </div>
        <div className="col-5">
          <WeatherTemperature celcius={props.data.temperature} />
        </div>
        <div className="col-5">
          <ul className="weatherFactors">
            <li>Feels Like: {props.data.feelsLike}°C</li>
            <li>Wind: {props.data.wind} km/h </li>
            <li>Humidity: {props.data.humidity}%</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
